// @flow
export type Action = {|
  type: 'SELECT_USAGE',
  payload: {| usage: any |},
|};

export const selectUsage = (usage: any): Action => ({
  type: 'SELECT_USAGE',
  payload: { usage },
});
